import React from "react";
import { Box, Container } from "@mui/system";
import {
  Button,
  Grid,
  List,
  ListItem,
  Skeleton,
  Typography,
} from "@mui/material";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export default function Layout2Section4({ acf }) {
  // console.log(acf);
  const navigate = useNavigate();

  const btnStyle = {
    border: "1px solid #000",
    color: "#000",
    borderRadius: "2rem",
    fontSize: "1rem",
    p: "0.5rem 1.5rem",
    mr: "1rem",
    mb: ".35rem",
    mt: "1rem",
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#FFF",
        py: 8,
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          transform: "translateZ(1px)",
        }}
      >
        <Grid container alignItems="center" spacing={4}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: {
                  xs: "100%",
                },
              }}
            >
              {acf?.heading && acf?.heading !== "" ? (
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 600,
                    mb: "1rem",
                    color: "#000",
                  }}
                  dangerouslySetInnerHTML={{ __html: acf.heading }}
                />
              ) : (
                <Skeleton
                  sx={{
                    maxWidth: "300px",
                  }}
                />
              )}

              {acf?.description && acf?.description !== "" ? (
                <Typography
                  variant="p"
                  component="p"
                  sx={{
                    color: "#000",
                  }}
                  dangerouslySetInnerHTML={{ __html: acf.description }}
                />
              ) : (
                <Skeleton
                  sx={{
                    maxWidth: "300px",
                  }}
                />
              )}

              {acf?.bullet_points_heading &&
              acf?.bullet_points_heading !== "" ? (
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mt: "1rem",
                    mb: "1rem",
                    color: "#000",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: acf.bullet_points_heading,
                  }}
                />
              ) : null}

              {acf?.bullet_points && acf?.bullet_points.length > 0 ? (
                <List
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  {acf.bullet_points.map((bullet_point, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        display: "flex",
                        pl: 0,
                        "&:before": {
                          display: "none",
                        },
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        size="xl"
                        style={{
                          color: "#E9531E",
                          marginRight: "10px",
                        }}
                      />
                      <Typography key={index}>
                        {bullet_point.bullet_point}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              ) : null}

              {acf?.button?.label && acf?.button?.label !== "" ? (
                <Button
                  sx={btnStyle}
                  onClick={() => {
                    console.log(acf?.button?.link);
                    // navigate(acf?.button?.link);
                    location.href = acf?.button?.link;
                  }}
                >
                  {acf.button.label}
                </Button>
              ) : null}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: {
                  xs: "100%",
                },
              }}
            >
              <img
                src={acf?.featured_image?.url}
                alt={acf?.featured_image?.alt}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
